/**
 * uriImage -> string = url de uma imagem
 * image -> string = imagem a ser inserida com base no nome do arquivo
 * dateNews -> string = data inserida no conteúdo do card
 * titleCard -> string = título do card
 * content -> string = conteúdo informativo central do card
 * labelBtn -> string = nome do botão do componente Btn
 * textColor -> string = cor da label/nome do componente Btn
 * pathNotice -> string = cor da path interno da
 */
import React, { useContext } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import getImage from "../../useFull/getImage";
import { useNavigate } from "react-router-dom";
import Btn from "../Btn/Btn";
import "./LatestNews.css";

const LatestNews = (props) => {
  const {
    image,
    dateNews,
    titleCard,
    content,
    labelBtn,
    textColor,
    uriImage,
    pathNotice,
    force,
  } = props;
  const { state } = useContext(GlobalContext);
  const language = state.language || "pt-br";
  const navigate = useNavigate();

  const url = `/notices/${language === "pt-br" ? pathNotice : `${pathNotice}/${language}`}`;

  const truncateContent = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }

    let truncatedText = text.substring(0, maxLength);
    const lastSpaceIndex = truncatedText.lastIndexOf(" ");

    if (lastSpaceIndex > 0) {
      truncatedText = truncatedText.substring(0, lastSpaceIndex);
    }

    return `${truncatedText} [...]`;
  };

  return (
    <div className="container-latest-news w-box-shadow">
      <div className="container-card-news">
        <div
          className="container-card-news-image"
          style={{
            backgroundImage: uriImage
              ? `url(${uriImage})`
              : `url(${getImage("card-news", image)})`,
          }}
        />
        <div className="card-news-date">
          <span>{dateNews}</span>
        </div>
        <div className="container-card-news-text">
          <div className="container-card-news-title">
            <span
              className="card-news-title"
              dangerouslySetInnerHTML={{ __html: titleCard }}
            ></span>
          </div>
          <div className="container-card-news-content">
            <span className="card-news-content">
              {truncateContent(content, 199)}
            </span>
          </div>
        </div>
        <div className="container-card-news-btn">
          <Btn
            label={labelBtn}
            textColor={textColor}
            type={"link"}
            className="btn-card-news"
            _function={() =>
              force ? (window.location.href = url) : navigate(url)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
